import { Instrument } from '../../types'

export const INSTRUMENT_CATEGORIES = [
  { name: 'All', instrument: undefined },
  { name: 'Stocks', instrument: Instrument.Stock },
  { name: 'Futures', instrument: Instrument.Futures },
  { name: 'Forex', instrument: Instrument.Forex },
  { name: 'Crypto', instrument: Instrument.Crypto },
]
